import { createContext } from 'react';

/**
 * Trigger types for the upgrade modal - determines contextual messaging
 */
export type UpgradeTrigger =
  | 'bill_tracking'
  | 'committee_tracking'
  | 'ai_summary'
  | 'notifications'
  | 'social_share'
  | 'similar_bills'
  | 'saved_searches'
  | 'full_text_search'
  | 'vote_comparison'
  | 'general';

interface UpgradeModalContextType {
  openUpgradeModal: (trigger: UpgradeTrigger) => void;
  closeUpgradeModal: () => void;
}

export const UpgradeModalContext = createContext<UpgradeModalContextType | null>(null);
